import React from "react";

import { AuthButton } from "../styles";

import { openSocialAuth } from "frontend/hooks/useAuth";

const FacebookAuthButton = ({ children }) => {
    return (
        <AuthButton
            data-testid="facebook-auth-button"
            onClick={e => {
                e.preventDefault();
                openSocialAuth();
            }}
        >
            {children}
        </AuthButton>
    );
};

export default FacebookAuthButton;
